import { useEffect } from "react"

/**
 * Bridges custom DOM events from the Stimulus controller to React handlers.
 * Listens for flow:addNode, flow:save, and flow:export on the canvas element.
 */
export default function useStimulusEvents(handleAddNode, handleSave, handleExport) {
  useEffect(() => {
    const canvas = document.querySelector("[data-react-flow-target='canvas']")
    if (!canvas) return

    canvas.addEventListener("flow:addNode", handleAddNode)
    canvas.addEventListener("flow:save", handleSave)
    canvas.addEventListener("flow:export", handleExport)

    return () => {
      canvas.removeEventListener("flow:addNode", handleAddNode)
      canvas.removeEventListener("flow:save", handleSave)
      canvas.removeEventListener("flow:export", handleExport)
    }
  }, [handleAddNode, handleSave, handleExport])
}
